
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Grid,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Chip,
  Stack
} from "@mui/material";
import {
  Add as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  PhotoCamera as PhotoCameraIcon
} from "@mui/icons-material";

const AddBusi = () => {
    
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    businessName: "",
    email: "",
    mobile: "",
    businessType: "",
    category: "",
    subCategory: "",
    keyword: "",
    gst: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pin: "",
    facebook: "",
    instagram: "",
    youtube: "",
    latitude: "",
    longitude: "",
    about: "",
    booking: false,
    liveLocation: false,
    changeShopLocation: false,
    profilePic: null,
    bannerImages: null,
    galleryImages: [],
    websites: [""],
  });

  const [businessType, setBusinessType] = useState([]);
  const [selectedBusinessType, setSelectedBusinessType] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [showWebsiteModal, setShowWebsiteModal] = useState(false);
  const [websiteName, setWebsiteName] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const fileInputRef = useRef();

  // Mock data since we don't have actual API endpoints
  useEffect(() => {
    // Simulating API calls with mock data
    setBusinessType([
      { _id: "1", title: "Retail" },
      { _id: "2", title: "Service" },
      { _id: "3", title: "Manufacturing" }
    ]);
    
    setCategories([
      { _id: "1", category_name: "Food & Beverage" },
      { _id: "2", category_name: "Technology" },
      { _id: "3", category_name: "Healthcare" }
    ]);
    
    setSubCategories([
      { _id: "1", subcategory_name: "Restaurant" },
      { _id: "2", subcategory_name: "Software" },
      { _id: "3", subcategory_name: "Clinic" }
    ]);
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setForm({ ...form, [name]: checked });
    } else if (type === "file") {
      if (name === "galleryImages") {
        setForm({ ...form, galleryImages: Array.from(files) });
      } else {
        setForm({ ...form, [name]: files[0] });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedForm = {
      ...form,
      businessType: selectedBusinessType,
      category: selectedCategory,
      subcategories: selectedSubCategory
    };

    // Upload profilePic to S3 if it exists and is a File
    if (form.profilePic && form.profilePic instanceof File) {
      try {
        const uniqueSuffix = Date.now() + "-" + Math.round(Math.random() * 1e9);
        // Mock upload logic
        //console.log("Uploading profile picture...");
      } catch (err) {
        //console.log(err);
        alert("Failed to upload profile picture.");
        return;
      }
    }

    // Mock API call
    //console.log("Form submitted:", updatedForm);
    alert("Form saved successfully!");
  };

  const handleGalleryChange = (e) => {
    const files = Array.from(e.target.files);
    setForm((prev) => ({
      ...prev,
      galleryImages: [...prev.galleryImages, ...files],
    }));
  };

  const handleRemove = (idx) => {
    setForm((prev) => ({
      ...prev,
      galleryImages: prev.galleryImages.filter((_, i) => i !== idx),
    }));
  };

  const addWebsite = () => {
    setForm(prev => ({
      ...prev,
      websites: [...prev.websites, { name: websiteName, url: websiteUrl }]
    }));
    setWebsiteName("");
    setWebsiteUrl("");
    setShowWebsiteModal(false);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 1200, mx: "auto", p: 2 }}>
      {/* Business Details Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5" component="h2" gutterBottom>
            Business Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Business Name"
                name="businessName"
                value={form.businessName}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Select Gender</InputLabel>
                <Select
                  name="gender"
                  value={form.gender}
                  onChange={handleChange}
                  label="Select Gender"
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Mobile Number"
                name="mobile"
                value={form.mobile}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth required>
                <InputLabel>Business Type</InputLabel>
                <Select
                  value={selectedBusinessType}
                  onChange={(e) => setSelectedBusinessType(e.target.value)}
                  label="Business Type"
                >
                  <MenuItem value="">Select Business Type</MenuItem>
                  {businessType.map((bt) => (
                    <MenuItem key={bt._id} value={bt.title}>
                      {bt.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth required>
                <InputLabel>Category</InputLabel>
                <Select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  label="Category"
                >
                  <MenuItem value="">Select Category</MenuItem>
                  {categories.map((cat) => (
                    <MenuItem key={cat._id} value={cat.category_name}>
                      {cat.category_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth required>
                <InputLabel>Sub Category</InputLabel>
                <Select
                  value={selectedSubCategory}
                  onChange={(e) => setSelectedSubCategory(e.target.value)}
                  label="Sub Category"
                >
                  <MenuItem value="">Select Sub Category</MenuItem>
                  {subcategories.map((subcat) => (
                    <MenuItem key={subcat._id} value={subcat.subcategory_name}>
                      {subcat.subcategory_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Keyword"
                name="keyword"
                value={form.keyword}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="GST Number"
                name="gst"
                value={form.gst}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Address Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" component="h3" gutterBottom>
            Address
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Line 1"
                name="address1"
                value={form.address1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Line 2"
                name="address2"
                value={form.address2}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={form.city}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="State"
                name="state"
                value={form.state}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Pin Code"
                name="pin"
                value={form.pin}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Links Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" component="h3" gutterBottom>
            Links
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Facebook"
                name="facebook"
                value={form.facebook}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Instagram"
                name="instagram"
                value={form.instagram}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="YouTube"
                name="youtube"
                value={form.youtube}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Location Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" component="h3" gutterBottom>
            Location
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Latitude"
                name="latitude"
                value={form.latitude}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Longitude"
                name="longitude"
                value={form.longitude}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Websites Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="h6" component="h3">
              Websites
            </Typography>
            <Button
              variant="contained"
              color="info"
              startIcon={<AddIcon />}
              onClick={() => setShowWebsiteModal(true)}
              size="small"
            >
              Add
            </Button>
          </Box>
          <Stack spacing={2}>
            {form.websites.map((site, idx) =>
              site.url ? (
                <Box key={idx} display="flex" alignItems="center" gap={2}>
                  <TextField
                    fullWidth
                    value={site.url}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                  <IconButton
                    color="error"
                    onClick={() => {
                      setForm(prev => ({
                        ...prev,
                        websites: prev.websites.filter((_, i) => i !== idx)
                      }));
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ) : null
            )}
          </Stack>
        </CardContent>
      </Card>

      {/* About Us Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" component="h3" gutterBottom>
            About Us *
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            name="about"
            value={form.about}
            onChange={handleChange}
            required
            placeholder="Enter About Us"
            sx={{ mb: 2 }}
          />
          <Stack spacing={1}>
            <FormControlLabel
              control={
                <Checkbox
                  name="booking"
                  checked={form.booking}
                  onChange={handleChange}
                />
              }
              label="Do you want booking service?"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="liveLocation"
                  checked={form.liveLocation}
                  onChange={handleChange}
                />
              }
              label="Do you want live location?"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="changeShopLocation"
                  checked={form.changeShopLocation}
                  onChange={handleChange}
                />
              }
              label="Do you want to change shop location?"
            />
          </Stack>
        </CardContent>
      </Card>

      {/* Images Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" component="h3" gutterBottom>
            Profile Picture *
          </Typography>
          <input
            type="file"
            name="profilePic"
            onChange={handleChange}
            required
            style={{ marginBottom: 24 }}
          />
          
          <Typography variant="h6" component="h3" gutterBottom>
            Banner Images *
          </Typography>
          <input
            type="file"
            name="bannerImages"
            onChange={handleChange}
            required
            style={{ marginBottom: 24 }}
          />

          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="h6" component="h3">
              Gallery Images
            </Typography>
            <Button
              variant="contained"
              color="info"
              startIcon={<PhotoCameraIcon />}
              onClick={() => fileInputRef.current.click()}
              size="small"
            >
              Add
            </Button>
          </Box>
          
          <input
            type="file"
            multiple
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleGalleryChange}
          />
          
          <Grid container spacing={2}>
            {form.galleryImages.map((file, idx) => (
              <Grid item xs={6} md={3} key={idx}>
                <Paper elevation={2} sx={{ position: "relative", p: 1 }}>
                  <img
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    style={{
                      width: "100%",
                      height: 120,
                      objectFit: "cover",
                      borderRadius: 4
                    }}
                  />
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleRemove(idx)}
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      bgcolor: "rgba(255,255,255,0.8)"
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Typography variant="caption" sx={{ display: "block", mt: 1, wordBreak: "break-word" }}>
                    {file.name}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {/* Action Buttons */}
      <Box display="flex" gap={2} mb={4}>
        <Button variant="outlined" color="error" size="large">
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<AddIcon />}
        >
          Save Business Details
        </Button>
      </Box>

      {/* Website Modal */}
      <Dialog open={showWebsiteModal} onHide={() => setShowWebsiteModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Website</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Website Name"
            value={websiteName}
            onChange={(e) => setWebsiteName(e.target.value)}
            required
            sx={{ mb: 2, mt: 1 }}
            placeholder="Enter Your Web Link Name"
          />
          <TextField
            fullWidth
            label="Website URL"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            placeholder="Enter your URL Here"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowWebsiteModal(false)} color="error" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={addWebsite}
            color="success"
            variant="contained"
            disabled={!websiteName}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddBusi;